import { configureStore } from "@reduxjs/toolkit";
import { rootApi } from "./api/apiManager";
import { rtkQueryErrorLogger } from "./api/rtkQueryErrorLogger";
import listenerMiddleware from "./api/websocket-middleware";
import authReducer from "./features/auth/auth-slice";
import billingSpaceFilterReducer from "./features/billing-space-filter/billing-space-filter-slice";
import notificationReducer from "./features/notification/notification-slice";
import siteChartFilterReducer from "./features/site-chart-filter/site-chart-filter-slice";
import sitesReducer from "./features/sites/sites-slice";
import solarFilterReducer from "./features/solar-filter/solar-filter-slice";
import usageGuideFilterReducer from "./features/usage-guide-filters/usage-guide-filters-slice";
import userReducer from "./features/user/user-slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    billingSpaceFilter: billingSpaceFilterReducer,
    usageGuideFilter: usageGuideFilterReducer,
    notifications: notificationReducer,
    solarFilter: solarFilterReducer,
    sites: sitesReducer,
    siteChartFilter: siteChartFilterReducer,
    [rootApi.reducerPath]: rootApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    // getDefaultMiddleware().concat([rootApi.middleware, rtkQueryErrorLogger]),
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat([rootApi.middleware, rtkQueryErrorLogger]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
